import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {Router} from '@angular/router';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {PersonLoginService} from '../services/person-login-service';
import {RoleName} from '../person/person-login';
import {DialogService} from '../services/dialog.service';
import {EntitySearchComponent} from '../entity/entity-search.component';
import {StringUtils} from '../utils/string-utils';

@Component({
    selector: 'quote-master',
    templateUrl: './quote-master.component.html',
    styleUrls: ['./quote-master.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EntitySearchComponent, MatButton, MatIcon]
})
export class QuoteMasterComponent {
  private readonly router = inject(Router);
  private readonly personLoginService = inject(PersonLoginService);
  private readonly dialogService = inject(DialogService);


  public entityName = "QUOTE";
  public showAllFilters: boolean = false;
  public canCreateStockQuote: boolean = false;
  readonly errorMessage = signal<string>(undefined!);

  constructor
  () {
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']);
    }
    this.showAllFilters = this.personLoginService.isInternalOrRsm() || this.personLoginService.isSiblingOrgUser();
    this.canCreateStockQuote = this.personLoginService.hasRole(RoleName.IT)
      || (!this.personLoginService.hasRole(RoleName.CredAnalyst) && !this.personLoginService.hasRole(RoleName.ReadOnly));
  }

  public newQuote(organizationId: string): void {
    if (organizationId && organizationId.length > 0) {
      this.router.navigate(['quotes/new/0'], {queryParams: {orgUnitId: organizationId}});
    } else {
      this.router.navigate(['quotes/new/0']);
    }
  }

  public goToDetail(entityHeader: any) {
    if (entityHeader) {
      this.router.navigate(['quotes', entityHeader.id.entityId, entityHeader.id.entityRevision]);
    }
  }

  public openStockUnitsDialog(): void {
    this.errorMessage.set(null!);
    this.dialogService.createStockQuoteFromDialog().subscribe({
      error: (error: any) => this.errorMessage.set(StringUtils.getErrorMessage(error))
    });
  }

}
